// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(10, 10, 10, 0.1);
  /*backdrop-filter: blur(10px);*/
}

.question {
  font-size: 4vmin;
  margin-bottom: 1rem;
  color: #fdf9f9;
  /* Color de texto oscuro */
  text-align: center;
}

@keyframes scale-down-right {
  0% {
    transform: scale(.2);
    transform-origin: right center;
  }

  100% {
    transform: scale(1);
    transform-origin: right center
  }
}

.options {
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: scale-down-right 0.4s;
  /* Espaciado entre opciones */
}

.royale-options {
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: scale-down-right 0.4s;
  margin-bottom: 14rem;
  /* Espaciado entre opciones */
}

.option {
  background-color: #fff;
  /* Color de fondo de la tarjeta */
  padding: 10px;
  border-radius: 5px;
  /* Bordes redondeados */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  /* Sombra de la tarjeta */
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  border: none;
}

.option:hover {
  transform: translateY(-5px);
  /* Efecto de elevación al pasar el ratón */
}

.button-correct {
  background-color: rgb(3, 191, 3);
  /* Añade una animación para hacer que el botón correcto parpadee */
  animation: blink 1s infinite alternate;
}

.button-incorrect {
  background-color: rgb(229, 11, 11);
  /* Añade una animación para hacer que el botón incorrecto vibre */
  animation: shake 0.5s cubic-bezier(.36, .07, .19, .97) both;
}

/* Define la animación blink */
@keyframes blink {
  from {
    opacity: 1;
  }

  to {
    opacity: 0.5;
  }
}

/* Define la animación shake */
@keyframes shake {

  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

.nextQuestion {
  background-color: #007BFF;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  border: none;
  align-self: flex-end;
  color: white
}

.nextQuestion:hover {
  transform: translateY(-5px);
  background-color: #0056b3;

  /* Efecto de elevación al pasar el ratón */
}`, "",{"version":3,"sources":["webpack://./src/components/questionDisplayer/questionDisplayer.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,kEAAkE;EAClE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,iEAAiE;EACjE,2DAA2D;AAC7D;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,8BAA8B;AAC9B;;EAEE;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;;IAGE,kCAAkC;EACpC;;EAEA;;IAEE,iCAAiC;EACnC;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,oBAAoB;EACpB;AACF;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;;EAEzB,0CAA0C;AAC5C","sourcesContent":[".question-container {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(10, 10, 10, 0.1);\n  /*backdrop-filter: blur(10px);*/\n}\n\n.question {\n  font-size: 4vmin;\n  margin-bottom: 1rem;\n  color: #fdf9f9;\n  /* Color de texto oscuro */\n  text-align: center;\n}\n\n@keyframes scale-down-right {\n  0% {\n    transform: scale(.2);\n    transform-origin: right center;\n  }\n\n  100% {\n    transform: scale(1);\n    transform-origin: right center\n  }\n}\n\n.options {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  animation: scale-down-right 0.4s;\n  /* Espaciado entre opciones */\n}\n\n.royale-options {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  animation: scale-down-right 0.4s;\n  margin-bottom: 14rem;\n  /* Espaciado entre opciones */\n}\n\n.option {\n  background-color: #fff;\n  /* Color de fondo de la tarjeta */\n  padding: 10px;\n  border-radius: 5px;\n  /* Bordes redondeados */\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  /* Sombra de la tarjeta */\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out;\n  border: none;\n}\n\n.option:hover {\n  transform: translateY(-5px);\n  /* Efecto de elevación al pasar el ratón */\n}\n\n.button-correct {\n  background-color: rgb(3, 191, 3);\n  /* Añade una animación para hacer que el botón correcto parpadee */\n  animation: blink 1s infinite alternate;\n}\n\n.button-incorrect {\n  background-color: rgb(229, 11, 11);\n  /* Añade una animación para hacer que el botón incorrecto vibre */\n  animation: shake 0.5s cubic-bezier(.36, .07, .19, .97) both;\n}\n\n/* Define la animación blink */\n@keyframes blink {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0.5;\n  }\n}\n\n/* Define la animación shake */\n@keyframes shake {\n\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n\n.nextQuestion {\n  background-color: #007BFF;\n  padding: 10px;\n  border-radius: 5px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out;\n  border: none;\n  align-self: flex-end;\n  color: white\n}\n\n.nextQuestion:hover {\n  transform: translateY(-5px);\n  background-color: #0056b3;\n\n  /* Efecto de elevación al pasar el ratón */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
